import React, { useEffect } from "react";
import Merchants from "./components/Merchants";
import Details from "./components/Details";
import ListDetailsSubLayout from "../../layout/ListDetailSubLayout";
import useMerchantStore from "../../stores/merchant";
import useCommonStore from "../../stores/common";

const MerchantPage = () => {
  useEffect(() => {
    return () => {
      useCommonStore.getState().reset();
      useMerchantStore.getState().reset();
    };
  }, []);

  return (
    <ListDetailsSubLayout
      detailsComponent={Details}
      listComponent={Merchants}
    />
  );
};

export default MerchantPage;
